import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PersonSearchResultDto } from 'src/shared/services/api.service';
import { PersonSearchParams } from 'src/shared/vouchers/voucher-person-search.component';

@Component({
  selector: 'cert-pd-person-search',
  standalone: false,
  templateUrl: './pd-person-search.component.html',
  styles: ``,
})
export class PdPersonSearchComponent {
  @Input() results: PersonSearchResultDto[] = [];
  @Input() searching = false;

  @Output() search = new EventEmitter<PersonSearchParams>();
  @Output() personSelected = new EventEmitter<PersonSearchResultDto>();

  firstName = '';
  lastName = '';
  ein = '';
  searchPerformed = false;

  selectedPersonId!: number | undefined;

  onSearch() {
    if (!this.firstName && !this.lastName && !this.ein) return;
    this.searchPerformed = true;
    this.searching = true;
    this.search.emit({ firstName: this.firstName, lastName: this.lastName, ein: this.ein, searchAllPersons: false });
  }

  onClear() {
    this.firstName = '';
    this.lastName = '';
    this.ein = '';
    this.searchPerformed = false;
    this.searching = false;
    this.search.emit({ firstName: '', lastName: '', ein: '', searchAllPersons: false });
  }

  onSelectPerson(person: PersonSearchResultDto) {
    this.selectedPersonId = person.personId;
    this.personSelected.emit(person);
  }

  isSelected(personId: number): boolean {
    return this.selectedPersonId === personId;
  }
}
